module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/146-gambia-d1f5edcb7a82b0147753c9569622e34f.svg";